module.exports = __webpack_public_path__ + "static/media/sidebar5.c0ab5569.jpg";